<app-dialog-container
    (closeEvent)="closeDialog()"
    [loading]="!filterInit"
    [title]="title"
>
    <div class="level is-full-width">
        <app-filter-input
            *ngFor="let filter of filters"
            [property]="filter"
            [disabledOptions]="filter.disabledOptions"
        ></app-filter-input>
    </div>
    <div class="level is-full-width">
        <div class="level-right">
            <app-button
                [class]="'level-item is-family-secondary'"
                [buttonText]="'Cancel'"
                [icon]="'fas fa-fw fa-times'"
                (buttonClick)="closeDialog()"
                [isLoading]="isLoading"
                [type]="'stroked'"
                [disabled]="isLoading"
                [isLoading]="isLoading"
            />

            <app-button
                [buttonText]="'Save'"
                [icon]="'fa-save'"
                (buttonClick)="validateAndClose()"
                [isLoading]="isLoading"
                [type]="'flat'"
            />
        </div>
    </div>
</app-dialog-container>
